/**
 * Created by liuxsen on 2017/10/13.
 */
import axios from 'axios'

let instance = axios.create();
const postHttp = function (url, param) {
  // instance.defaults.headers.common['token'] = localStorage.getItem("ra_token");
  // Add a request interceptor
  instance.interceptors.request.use(function (config) {

    return config;
  }, function (error) {
    // Do something with request error
    return Promise.reject(error);
  });

  // Add a response interceptor
  instance.interceptors.response.use(function (response) {
    // Do something with response data

    return response;
  }, function (error) {
    // Do something with response error
    return Promise.reject(error);
  });
  //测试环境和生产环境地址不一样 加了一个前缀的判断  此项目先有生产环境再有的测试环境。
  return instance.post(url, param);
};

export function getHttp(url) {
  // instance.defaults.headers.common['token'] = localStorage.getItem("ra_token");
  // Add a request interceptor
  instance.interceptors.request.use(function (config) {

    return config;
  }, function (error) {
    // Do something with request error
    return Promise.reject(error);
  });

  // Add a response interceptor
  instance.interceptors.response.use(function (response) {
    // Do something with response data

    return response;
  }, function (error) {
    // Do something with response error
    return Promise.reject(error);
  });
  //测试环境和生产环境地址不一样 加了一个前缀的判断  此项目先有生产环境再有的测试环境。
  return instance.get(url);
}

export default postHttp;



// WEBPACK FOOTER //
// ./src/plugin/extendFn/postHttp.js